var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0752 48.151C37.3502 48.151 48.1501 37.3506 48.1501 24.0754C48.1501 10.8004 37.3502 0 24.0752 0C10.8001 0 0 10.8004 0 24.0754C0 37.3506 10.8001 48.151 24.0752 48.151ZM24.0752 3.29574C35.5329 3.29574 44.8544 12.6174 44.8546 24.0754C44.8546 35.5334 35.5331 44.855 24.0752 44.8553C12.6174 44.855 3.29596 35.5334 3.29596 24.0752C3.29596 12.6176 12.6174 3.29574 24.0752 3.29574Z",
    fill: "#1ea149"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8421 34.3871C21.4856 35.0304 22.5291 35.0302 23.1724 34.3871C23.8161 33.7433 23.8161 32.7001 23.1722 32.0563L16.8399 25.7243L35.1768 25.7226C36.0869 25.7224 36.8244 24.9848 36.8244 24.0743C36.8242 23.1642 36.0866 22.4268 35.1766 22.4268L16.8391 22.4286L23.1728 16.0953C23.8164 15.4517 23.8164 14.4081 23.1728 13.7648C22.8509 13.4431 22.4293 13.282 22.0074 13.282C21.5858 13.282 21.1642 13.4431 20.8423 13.7645L11.6957 22.9109C11.3866 23.2198 11.213 23.6388 11.213 24.076C11.2132 24.5133 11.3868 24.9321 11.6959 25.2416L20.8421 34.3871Z",
    fill: "#1ea149"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.70db73b50d31e836ff5acde8eafcd873.svg";
export { ForwardRef as ReactComponent };